import {
	type Control,
	Controller,
	type FieldPathByValue,
	type FieldValues,
} from "react-hook-form";
import { FlatRowStackedInput } from "web_myplann/Shared/Components/FlatRow/FlatRowStackedInput";

type Props<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: FieldPathByValue<FormType, string>;
	label: string;
	placeholder?: string;
	isLast?: boolean;
};

export const FlatRowFormStackedInput = <
	FormType extends FieldValues,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	placeholder,
	isLast,
}: Props<FormType, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange } }) => (
			<FlatRowStackedInput
				label={label}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				isLast={isLast}
			/>
		)}
	/>
);
